import React, { useContext, useEffect, useState } from 'react';
import { AppState, ScrollView, StyleSheet, View } from 'react-native';
import { Text } from '@rneui/base';
import { StdUnitsInput } from '../components/StdUnitsInput';
import dayjs from 'dayjs';
import _ from 'lodash';
import ConsumptionContext from '../consumption-context';
import AddCommentButton from '../components/buttons/AddCommentButton';

const TodayScreen = ({
  navigation,
  userDoc,
  addConsumption,
  addOrUpdateDailyComment,
  consumptionTodayByUnit,
  totalConsumption,
}) => {
  const { dailyComments } = useContext(ConsumptionContext);
  const [currentDayjs, setCurrentDays] = useState(dayjs());

  useEffect(() => {
    const subscription = AppState.addEventListener(
      'change',
      handleAppStateChange
    );

    return () => {
      subscription.remove();
    };
  }, []);

  useEffect(() => {
    const unsubscribe = navigation.addListener('tabPress', (e) => {
      setCurrentDays(dayjs());
    });
    return unsubscribe;
  }, [navigation]);

  const handleAppStateChange = (nextAppState) => {
    if (nextAppState === 'active') {
      setCurrentDays(dayjs());
    }
  };

  const dateString = currentDayjs.format('YYYY-MM-DD');
  return (
    <ScrollView contentContainerStyle={{ paddingHorizontal: 20 }}>
      <Text h4 h4Style={{ marginTop: 20, color: 'grey' }}>
        {_.capitalize(currentDayjs.format('dddd'))} {currentDayjs.format('DD')}{' '}
        {currentDayjs.format('MMM')}
      </Text>
      <View style={styles.card}>
        <StdUnitsInput
          addConsumption={addConsumption}
          consumptionGoal={userDoc}
          consumptionTodayByUnit={consumptionTodayByUnit}
          totalConsumption={totalConsumption}
        />
      </View>
      <View style={{ marginTop: 20 }}>
        <AddCommentButton
          addOrUpdateDailyComment={(comment) =>
            addOrUpdateDailyComment(dateString, comment)
          }
          dailyComment={
            dailyComments?.find((c) => c.date === dateString)?.comment
          }
        />
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  card: {
    marginTop: 20,
    padding: 10,
    borderColor: 'lightgrey',
    borderRadius: 3,
    borderWidth: 1,
  },
});

export default TodayScreen;
